import { required, minLength, email } from 'vuelidate/lib/validators';
import isTrue from '../../../../common/validators/is-true';
import pattern from '../../../../common/validators/pattern';
import callRequestFormBase from '../../../call-request-form-base/call-request-form-base';
import eventBus from '../../../../common/event-bus/event-bus';
import { NAME_REGEXP, MOBILE_PHONE_REGEXP, ZIPCODE_REGEXP } from '../../../../common/constants/constants';
import { getData } from '../../../../common/store/store';
import { mapState } from 'vuex';

const CALLBACK_REQUEST_SUCCESS = 'callbackRequestSuccess';
const CALLBACK_REQUEST_FAILED = 'callbackRequestFailed';
const ZIP_CODE_LABEL = 'Irányítószám';
export default {
	extends: callRequestFormBase,
	data() {
		return {
			hasZipCodeTooltip: true,
			lahiCalculationResult: null,
			model: {
				zipCode: ''
			}
		};
	},
	props: {
		lahiSessionId: {},
		requestZipCode: {
			type: Boolean,
			default: false
		},
		sendData: {
			type: Boolean
		}
	},
	validations() {
		let validationObj = {
			model: {
				name: {
					required,
					minLength: minLength(5),
					pattern: pattern(NAME_REGEXP)
				},
				zipCode: this.requestZipCode
					? {
							required,
							pattern: pattern(ZIPCODE_REGEXP)
					  }
					: {},
				email: {
					required,
					email
				},
				phoneNumber: {
					required,
					pattern: pattern(MOBILE_PHONE_REGEXP)
				}
			},
			captchaError: {
				isTrue
			}
		};
		if (this.captcha && this.captcha.htmlFragment) {
			validationObj.model.captcha = {
				required
			};
		}
		return validationObj;
	},
	watch: {
		'model.time'(val) {
			if (val && this.timetable) {
				this.timeText = this.timetable.find(item => item.id == val).description;
			}
		},
		sendSucceeded(val) {
			if (val) {
				this.sendGtm(true);
				this.changeModalWidth();
			}
		},
		sendFailed(val) {
			if (val) {
				this.sendGtm(false);
				this.changeModalWidth();
			}
		},
		captcha(val) {
			if (val && val.htmlFragment) {
				this.$gtm.trackEvent({
					event: 'callbackRequestShownWithCaptcha'
				});
			}
		},
		lahiSessionId(newValue) {
			if (newValue) {
				this.model.other = newValue;
			}
		}
	},
	computed: {
		...mapState(['vhkId']),
		zipCodeLabel: () => ZIP_CODE_LABEL,
		zipCodeErrorRequired: () => this.$t('zipCode.error.required'),
		zipCodeErrorPattern: () => this.$t('zipCode.error.pattern')
	},
	methods: {
		sendGtm(success) {
			this.$gtm.trackEvent({
				event: success ? CALLBACK_REQUEST_SUCCESS : CALLBACK_REQUEST_FAILED,
				homeLoanAmount: this.lahiCalculationResult && this.sendData ? this.lahiCalculationResult.amount : undefined,
				homeLoanTerm: this.lahiCalculationResult && this.sendData ? this.lahiCalculationResult.duration / 12 : undefined,
				homeLoanInterestRate: this.lahiCalculationResult && this.sendData ? this.lahiCalculationResult.installment : undefined,
				homeLoanName: this.lahiCalculationResult && this.sendData ? this.lahiCalculationResult.officialName : undefined,
				vhk: this.vhkId
			});
		},

		changeModalWidth() {
			if (window.portalEventBus && this.modalId) {
				window.portalEventBus.$changeModalWidth(this.modalId, 'narrow');
			}
		},
		resetForm() {
			let other = this.model.other;
			this.model = {
				name: '',
				phoneNumber: '',
				email: '',
				time: this.timetable && this.timetable[0] ? this.timetable[0].id : null,
				captcha: '',
				captchaToken: null,
				other
			};
			this.$v.$reset();
		},
		handlePayload(payload) {
			this.model.other = payload.sessionId;
			this.lahiCalculationResult = payload.lahiCalculationResult;
			this.$emit('on-lahi-session-id-change', payload.sessionId);
		}
	},
	mounted() {
		const payload = getData();
		if (payload) {
			this.handlePayload(payload);
		}
		eventBus.$on('set-payload', this.handlePayload);
	}
};
